export default class QuestionnaireType {}

QuestionnaireType.Allergies = 'ALLERGIES';
QuestionnaireType.AllergyEvaluation = 'ALLERGY_EVALUATION';
QuestionnaireType.ExistingAllergy = 'EXISTING_ALLERGY';
QuestionnaireType.FleaAndTick = 'FLEA_AND_TICK';
